import {
  IN_PROGRESS_COLOR,
  SUCESS_COLOR,
  ERROR_COLOR,
} from 'src/consts/common';

export const API_MESSAGE_ERROR =
  'Houve um erro de comunicação. Verifique sua conexão e tente novamente mais tarde.';

export const GET_MESSAGE_STATUS_OF_TRIBUTE = {
  1: { mensage: 'Em Andamento', color: IN_PROGRESS_COLOR },
  2: { mensage: 'Concluido', color: SUCESS_COLOR },
  3: { mensage: 'Cancelado', color: ERROR_COLOR },
  5: { mensage: 'Realizando Cotação', color: IN_PROGRESS_COLOR },
  6: { mensage: 'Proposta Enviada', color: SUCESS_COLOR },
};
